import React, { useState, useEffect, useCallback } from "react";
import kendo from "@progress/kendo-ui";
// import { useHistory } from "react-router-dom";
import { Person, Lock } from "@material-ui/icons";
import sha512 from "js-sha512";
import "./login.css";

import { login, setToken, isLogin } from "../../service/authService";
import { getMessage } from "../../com/messageUtil";

function Login({ conn, setUpdateLoginStatus }) {
  document.body.style.backgroundColor = "#ECECEC";

  let [id, setId] = useState("");
  let [password, setPassword] = useState("");

  const inputChage = event => {
    if (event.target.name === "id") {
      setId(event.target.value);
    } else {
      setPassword(event.target.value);
    }
  };

  useEffect(() => {}, []);

  const appKeyPress = e => {
    if (e.key === "Enter") {
      clickLogin();
    }
  };

  const clickLogin = () => {
    if (id === "") {
      kendo.alert("아이디를 입력해주세요.");
      return;
    }
    if (password === "") {
      kendo.alert("비밀번호를 입력해주세요.");
      return;
    }
    const encryptPw = sha512.sha512(password);
    login(conn, id, password)
      .then(result => {
        setToken(result.token);
        setUpdateLoginStatus(true);
      })
      .catch(e => {
        alert(getMessage(e.errCode));
      });
  };

  return (
    <div id="login" className="login_page_wrapper">
      <div className="md-card">
        <div className="md-card-content loginShadow">
          <div className="login_heading">
            <div className="login_title">안심박스 모니터링 서비스</div>
          </div>
          <div>
            <div className="uk-form-row">
              <span className="md-input-icon">
                <Person className="material-icons" />
              </span>
              <input className="md-input" type="text" name="id" placeholder="ID" onChange={inputChage} />
            </div>
            <div className="uk-form-row">
              <span className="md-input-icon">
                <Lock className="material-icons" />
              </span>
              <input className="md-input" type="password" name="password" placeholder="PW" onChange={inputChage} onKeyPress={appKeyPress} />
            </div>
            <div className="uk-form-row-btn">
              <button className="md-btn-large BtnBg BtnText" onClick={clickLogin}>
                로그인
              </button>
            </div>
          </div>
          <div className="login_logo">
            <table>
              <tbody>
                <tr>
                  {/* <td><img src="assets/img/logo_chun.png" alt="천안시"/></td> */}
                  <td>
                    {/* <img src="/images/logo_chun.png" alt="제이케이코어" /> */}
                    {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                    <img src="/images/jkcore_1.png" alt="제이케이코어" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div id="errorTxt" className="errorTxt">
            등록되지 않은 아이디이거나, 아이디 또는 비밀번호가 일치하지 않습니다.
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
